export function normalizeBackendMessageKey(rawKey: unknown): string | null {
  if (!rawKey || typeof rawKey !== 'string') {
    return null;
  }

  const legacyToCanonical: Record<string, string> = {
    'errors.notAuthorized': 'ERRORS.NOT_AUTHORIZED',
    'errors.seatLimitReached': 'ERRORS.SEAT_LIMIT_REACHED_CONTACT',
    'errors.seatLimitReachedContact': 'ERRORS.SEAT_LIMIT_REACHED_CONTACT',
    'errors.lastCompanyAdminProtection': 'ERRORS.LAST_COMPANY_ADMIN_PROTECTION',
    'errors.inviteInvalidOrExpired': 'ERRORS.INVITE_INVALID_OR_EXPIRED',
    'errors.badRequest': 'ERRORS.BAD_REQUEST',
    'errors.userAlreadyExists': 'ERRORS.USER_ALREADY_EXISTS_IN_COMPANY',
    'errors.companyAlreadyExistsUseInvite': 'ERRORS.COMPANY_ALREADY_EXISTS_USE_INVITE',
  };

  return legacyToCanonical[rawKey] || rawKey;
}

export function shouldSuppressGenericError(err: any): boolean {
  const payload = err?.error ?? err;
  const key = normalizeBackendMessageKey(payload?.messageKey || payload?.message_key || null);
  const code = payload?.code;

  return key === 'ERRORS.MISSING_PERMISSION'
    || key === 'ERRORS.NOT_AUTHORIZED'
    || key === 'ERRORS.SEAT_LIMIT_REACHED_CONTACT'
    || err?.status === 403
    || err?.status === 409
    || code === 'FORBIDDEN'
    || code === 'SEAT_LIMIT_REACHED'
    || payload?.__handledByGlobalErrorHandler === true;
}

export function isForbiddenError(err: any): boolean {
  const payload = err?.error ?? err;
  const key = normalizeBackendMessageKey(payload?.messageKey || payload?.message_key || null);

  return err?.status === 403
    || payload?.code === 'FORBIDDEN'
    || (typeof key === 'string' && key.startsWith('ERRORS.'));
}

export function isSeatLimitError(err: any): boolean {
  const payload = err?.error ?? err;
  const key = normalizeBackendMessageKey(payload?.messageKey || payload?.message_key || null);
  return payload?.code === 'SEAT_LIMIT_REACHED' || key === 'ERRORS.SEAT_LIMIT_REACHED_CONTACT';
}
